<template>
  <b-card>
    <DeleteAdModal
      :id="adID"
      :screen-id="screenID"
      @deleted="fetchAds"
    />
    <EditAdModal
      :ad-id="editAdID"
      :current-rank="currentRank"
      :screen="editScreen"
      @updated="fetchAds"
    />
    <b-button
      v-if="$can('write', 'advertisement')"
      class="mb-1"
      variant="primary"
      to="/advertisements/create-new"
    >
      Create New Ad
    </b-button>
    <base-overlay :show="fetchingAds">
      <b-table
        :fields="columns"
        :items="adsList"
      >
        <template #cell(show_details)="row">
          <b-button
            size="sm"
            class="mr-2"
            variant="primary"
            @click="row.toggleDetails"
          >
            {{ row.detailsShowing ? 'Hide' : 'Show' }} Ads
          </b-button>
        </template>
        <template #row-details="row">
          <b-table
            :fields="adColumns"
            :items="row.item.advertisement"
          >
            <template #cell(id)="data">
              <span
                style="cursor: pointer; color: blue; text-decoration: underline;"
                @click="rowClicked(data.item)"
              >{{ data.item.id }}</span>
            </template>
            <template #cell(startAt)="data">
              {{ formatDate(data.item.startAt) }}
            </template>
            <template #cell(endAt)="data">
              {{ formatDate(data.item.endAt) }}
            </template>
            <template #cell(actions)="activeRow">
              <b-button
                v-if="$can('write', 'advertisement')"
                size="sm"
                variant="info"
                class="mr-1"
                @click="editAdHandler(activeRow.item.id, activeRow.item.rank, row.item.id)"
              >
                Edit
              </b-button>
              <b-button
                v-if="$can('delete', 'advertisement')"
                size="sm"
                variant="danger"
                @click="deleteAdHandler(activeRow.item.id, row.item.id)"
              >
                Delete
              </b-button>
            </template>
          </b-table>
        </template>
      </b-table>
    </base-overlay>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import { BTable, BButton, BCard } from 'bootstrap-vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '../store'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import DeleteAdModal from '../components/DeleteAdModal.vue'
import EditAdModal from '../components/EditAdModal.vue'

export default {
  components: {
    BaseOverlay,
    BTable,
    DeleteAdModal,
    EditAdModal,
    BButton,
    BCard,
  },
  setup(_, ctx) {
    useRegisterStoreModule('ads', store)

    const columns = [
      {
        label: 'Ad id',
        key: 'id',
        formatter: val => (val ? snakeCaseToCamelCase(val.split(':')[1]) : ''),
      },
      {
        label: 'Expand Ads',
        key: 'show_details',
      },
    ]
    const adColumns = [
      {
        label: 'id',
        key: 'id',
      },
      {
        label: 'Rank',
        key: 'rank',
      },
      {
        label: 'Start Date',
        key: 'startAt',
      },
      {
        label: 'End Date',
        key: 'endAt',
      },
      'actions',
    ]
    const fetchingAds = ref(false)
    const adsList = ref([])
    const fetchAds = async () => {
      fetchingAds.value = true
      const res = await ctx.root.$store.dispatch('ads/getAdsList')
      const { data } = res.data
      adsList.value = data.filter(ad => ad.advertisement.length)
      fetchingAds.value = false
    }

    fetchAds()

    const screenID = ref('')
    const adID = ref('')
    const editAdID = ref('')
    const currentRank = ref(0)
    const editScreen = ref('')

    const deleteAdHandler = (adId, screenId) => {
      const screenIdTemp = screenId.split(':')[1]
      screenID.value = screenIdTemp
      adID.value = adId

      ctx.root.$bvModal.show('delete-ad-modal')
    }

    const editAdHandler = (adId, rank, screenId) => {
      const screenIdTemp = screenId.split(':')[1]
      editAdID.value = adId
      currentRank.value = rank || 0
      editScreen.value = screenIdTemp

      ctx.root.$bvModal.show('edit-ad-modal')
    }

    const rowClicked = ev => {
      const imgURL = ev.url || ev.image
      window.open(imgURL || '')
    }

    const formatDate = dateString => {
      if (!dateString) return '-'
      
      try {
        const date = new Date(dateString)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        
        return `${year}-${month}-${day} ${hours}:${minutes}`
      } catch (error) {
        return '-'
      }
    }

    return {
      deleteAdHandler,
      editAdHandler,
      adColumns,
      columns,
      fetchAds,
      fetchingAds,
      adsList,
      adID,
      screenID,
      editAdID,
      currentRank,
      editScreen,
      rowClicked,
      formatDate,
    }
  },
}
</script>
